import React from 'react';

function LoaderOverlay({ isLoading, message }) {
  if (!isLoading) {
    return null;
  }

  return (
    <div className="loader-overlay">
      <div className="loader"></div>
      <p>{message || 'Processando...'}</p>
    </div>
  );
}

export default LoaderOverlay;